// 02 · Ingresa a tu cuenta (v3.4): campos vidrio, foco #3A4BFF, error con
// ambos campos en --neg y un solo mensaje, link de recuperación en acento
// al fallar, bloqueo de 60 s tras 5 fallos (cuenta regresiva en el CTA).
// Auth real: loginWithEmail / loginWithGoogle (AppShell detecta el user).
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithEmail, loginWithGoogle, authErrorMessage } from '../../../auth/authHelpers';
import { I, Wordmark } from '../ui';

const MSG_CRED = 'Correo o contraseña incorrectos. Revísalos e inténtalo de nuevo.';
const CRED_CODES = /invalid-credential|wrong-password|user-not-found|invalid-email|invalid-login/i;

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [fails, setFails] = useState(0);
  const [lockUntil, setLockUntil] = useState(0);
  const [now, setNow] = useState(Date.now());

  const locked = lockUntil > now;
  useEffect(() => {
    if (!locked) return undefined;
    const t = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(t);
  }, [locked]);
  const left = Math.max(0, Math.ceil((lockUntil - now) / 1000));

  const submit = async () => {
    if (loading || locked) return;
    if (!/^\S+@\S+\.\S+$/.test(email) || pass.length < 1) { setError(MSG_CRED); return; }
    setError(''); setLoading(true);
    try {
      await loginWithEmail(email.trim(), pass);
    } catch (err) {
      const n = fails + 1; setFails(n);
      setError(CRED_CODES.test(String(err?.code || err?.message || '')) ? MSG_CRED : authErrorMessage(err));
      if (n >= 5) { setLockUntil(Date.now() + 60e3); setFails(0); }
      setLoading(false);
    }
  };
  const google = async () => {
    if (loading) return;
    setError(''); setLoading(true);
    try { await loginWithGoogle(); setLoading(false); } catch (err) { setError(authErrorMessage(err)); setLoading(false); }
  };

  return (
    <div className="v3"><div className="lg-wrap">
      <div className="lg-top"><Wordmark width={152} /></div>
      <h1 className="lg-h" style={{ marginTop: 0 }}>Ingresa a tu cuenta</h1>
      <p className="lg-p">Accede a las señales del día y a tu historial completo.</p>
      <div className="fields" style={{ marginTop: 28 }}>
        <div className={`fld${error ? ' err' : ''}`}><p className="l">Correo</p><div className="row2">
          <input type="email" inputMode="email" autoComplete="email" placeholder="tu@correo.com" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && submit()} />
        </div></div>
        <div className={`fld${error ? ' err' : ''}`}><p className="l">Contraseña</p><div className="row2">
          <input type={show ? 'text' : 'password'} autoComplete="current-password" placeholder="••••••••••" value={pass} onChange={(e) => setPass(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && submit()} />
          <button type="button" className="eye" aria-label="Mostrar contraseña" onClick={() => setShow((s) => !s)}><I.eye /></button>
        </div></div>
        {error && <p className="fld-err">{error}</p>}
      </div>
      <button type="button" className={`forgot${error ? ' acc' : ''}`} style={{ background: 'none', border: 'none', padding: 0, fontFamily: 'inherit' }} onClick={() => navigate('/app/recuperar')}>¿Olvidaste tu contraseña?</button>
      <button type="button" className="cta" style={{ marginTop: 20 }} onClick={submit} disabled={loading || locked}>
        {locked ? `Reintenta en 0:${String(left).padStart(2, '0')}` : loading ? 'Entrando…' : <>Ingresar<I.arrow /></>}
      </button>
      <div className="orx">o continúa con</div>
      <div className="soc"><button type="button" onClick={google} disabled={loading}><I.google />Google</button></div>
      <p className="lg-foot">¿Aún no tienes cuenta? <strong onClick={() => navigate('/app/registro')}>Crear cuenta</strong></p>
    </div></div>
  );
}
